// this is intentionally very high because init is critical for the app to work
export const WAIT_FOR_LD_TIMEOUT_SECONDS = 10;

export const privateAttributes = [
  'email',
  'firstName',
  'lastName',
  'name',
  'dateOfBirth',
  'phoneNumber',
];
